import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=6ab320ce&scoped=true&"
import script from "./MainFrame.vue?vue&type=script&lang=js&"
export * from "./MainFrame.vue?vue&type=script&lang=js&"
import style0 from "./MainFrame.vue?vue&type=style&index=0&id=6ab320ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab320ce",
  null
  
)

export default component.exports